module.exports = __webpack_public_path__ + "static/img/logo5.690e5f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo5.png
// module id = 440
// module chunks = 4 5 6